import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import aiAccounting from "./../../assets/images/banner/solutions-banner.jpg";
import { useState } from "react";
const useCasesData = {
  "Cloudera Initial Setup": [
    "Get started with the Cloudera Platform in your data center",
    "Design and deploy a Cloudera cluster following industry best practices",
    "Implement enhanced security for authentication, authorization, auditing, and data governance",
    "Deliver an Edge-to-AI use case that demonstrates measurable business value",
  ],

  "Cloudera Migrate": [
    "Assess and plan migration to an optimized hybrid architecture",
    "Upgrade legacy Cloudera CDH or HDP deployments to the latest supported versions",
    "Migrate on-premise CDH or HDP workloads to Cloudera Data Platform (CDP)",
  ],

  "Cloudera Cloud Analytics": [
    "Kick-start your cloud analytics journey with CDP on public cloud",
    "Enable shift-to-cloud and burst-to-cloud adoption scenarios",
    "Provide the right level of support for onboarding, planning, and acceleration",
  ],

  "Cloudera Upgrade": [
    "Perform a comprehensive platform health check and use-case assessment",
    "Create an in-place upgrade and migration plan based on best practices",
    "Upgrade existing CDH or HDP deployments to CDP with minimal disruption",
  ],

  "Cloudera Motion": [
    "Enable real-time analytics using Cloudera DataFlow (CDF)",
    "Design and implement a scalable Data-in-Motion architecture",
    "Deliver streaming analytics use cases for real-time insights",
  ],

  "Cloudera Health": [
    "Conduct a comprehensive platform health check for optimal performance",
    "Review clusters, data, applications, security, governance, and operations",
    "Apply prioritized recommendations for performance, stability, and scalability",
  ],
};

const Data_Administrator = () => {
  pageTitle("Data Administrator");
  const [activeTab, setActiveTab] = useState(Object.keys(useCasesData)[0]);
  return (
    <>
      <HeaderOne></HeaderOne>
      <div className="ai-overlay-wrapper" style={{ backgroundImage: `url(${aiAccounting})` }}>
        {/* <img src={aiAccounting} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          <h2 className="rpa-af-title mt-0 mb-2">Data Administration</h2>
          <p className="featuring">
            <img
              src="static/media/cloudera-partner-badge.bea6d1f0f7f1dfc2b1c8.jpg"
              alt="cloudera"
              className="feature-logo"
            />
          </p>
        </div>
      </div>

      <section class="siw-rpa-section-da">
        <div class="siw-rpa-container-data-engineering container">
          <div class="siw-rpa-content">
            <span class="siw-rpa-tag">
              Cloudera & Cloud Administration Services
            </span>

            <div className="siw-rpa-text">
              <p>
                We deliver end-to-end Cloudera CDP administration and managed
                services across on-premises and cloud (AWS) environments,
                helping enterprises build secure, scalable, and highly available
                big data platforms.
              </p>
            </div>
            <div className="service__right">
              <h3 style={{ padding: "20px 0 10px" }}>What We Do</h3>
              <h4 style={{ padding: "10px 0 0px" }}>
                Cloudera CDP Platform Management
              </h4>
            </div>
            <ul class="siw-rpa-desc">
              <li>
                Administration of Cloudera CDP 7.1.7 across on-prem and cloud
                infrastructure
              </li>
              <li>
                Design and deployment of high-availability, load-balanced
                clusters across Production, QA, and Development
              </li>
              <li>
                Independent setup and lifecycle management aligned with Cloudera
                best practices
              </li>
            </ul>
          </div>

          <div className="siw-rpa-cta">
            <h4
              style={{
                textAlign: "center",
                color: "rgb(230, 233, 55)",
              }}
            >
              Let’s Build Your Data Platform<br></br>
            </h4>
            <p>
              Whether you’re modernizing your data lake, moving to the cloud, or
              enabling real-time analytics, we help you turn data into trusted,
              actionable intelligence.
            </p>
            <h4>
              Contact us{" "}
              <a href="tel:+6586605048" style={{ color: "rgb(230, 233, 55)" }}>
                +65 86605048
              </a>{" "}
              to discuss your Data Administration requirements
            </h4>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              SCHEDULE A MEETING
            </a>
          </div>
        </div>
      </section>

      <div className="service__details-da p_relative ">
        <div className="auto-container">
          <div className="row">
            <div className=" col-lg-12 col-md-12">
              <div className="service__right">
                <h4 style={{ padding: "0px" }} className="da-h4">
                  Security & Governance
                </h4>
                <ul class="siw-rpa-desc">
                  <li>
                    Kerberos authentication with Active Directory (AD)
                    integration
                  </li>
                  <li>Role-based access control using Apache Ranger</li>
                  <li>HDFS ACLs, encrypted zones, log and query redaction</li>
                  <li>Secure Hue authentication and authorization</li>
                  <li>
                    Built to meet enterprise and regulatory security policies
                  </li>
                </ul>

                <h4 style={{ padding: "0px" }} className="da-h4">
                  Automation & DevOps
                </h4>
                <ul class="siw-rpa-desc">
                  <li>
                    Automated cluster installation and configuration using
                    Ansible
                  </li>
                  <li>
                    Scripted operational workflows to reduce manual effort and
                    risk
                  </li>
                  <li>
                    Automated deployment of Cloudera Manager, CDP/CDH, and
                    ecosystem services
                  </li>
                  <li>
                    OS-level and repository setup for enterprise Hadoop
                    environments
                  </li>
                </ul>
                <h4 style={{ padding: "0px" }} className="da-h4">
                  High Availability & Configuration
                </h4>
                <ul class="siw-rpa-desc">
                  <li>
                    Configuration of NameNode and ResourceManager High
                    Availability
                  </li>
                  <li>
                    Advanced tuning of HDFS, Hive, Impala, and supporting
                    services
                  </li>
                  <li>Proxy configuration for HiveServer2 and Impala</li>
                  <li>
                    OS-level and repository setup for enterprise Hadoop
                    environments
                  </li>
                </ul>

                <h4 style={{ padding: "0px" }} className="da-h4">
                  Operations & Support
                </h4>

                <ul class="siw-rpa-desc">
                  <li>Day-to-day cluster operations and maintenance</li>
                  <li>
                    Proactive monitoring, alerting, and capacity management
                  </li>
                  <li>
                    Cluster rebalancing and node commissioning/decommissioning
                  </li>
                  <li>
                    L3-level production support for mission-critical
                    environments
                  </li>
                </ul>
                <h4 style={{ padding: "0px" }} className="da-h4">
                  Performance Optimization
                </h4>

                <ul class="siw-rpa-desc">
                  <li>
                    Benchmarking of platform performance and operational metrics
                  </li>
                  <li>
                    Fine-tuning configurations to maximize efficiency and
                    stability
                  </li>
                  <li>Root-cause analysis and proactive issue prevention</li>
                </ul>
                <h4 style={{ padding: "0px" }} className="da-h4">
                  Backup, Recovery & Data Management
                </h4>

                <ul class="siw-rpa-desc">
                  <li>Efficient data movement within and across clusters</li>
                  <li>HDFS snapshot creation and restoration</li>
                  <li>ACL management across enterprise data structures</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="data-engineering-highlight">
        <div className="data-engineering-container container">
          {/* LEFT CONTENT CARD */}
          <div className="data-engineering-card data-engineering-card-main">
            <h2 className="data-engineering-title">Why Choose Us</h2>

            <ul className="data-engineering-list">
              <li>Deep expertise in enterprise and banking environments</li>
              <li>Proven experience across on-prem and cloud platforms</li>
              <li>Strong focus on security, compliance, and reliability</li>
              <li>
                Automation-first approach for faster delivery and lower
                operational risk
              </li>
            </ul>

            <div className="row bg-white da-usecases-card">
              <div className="col-md-4 p-0 ai-ml-usecases-left">
                {Object.keys(useCasesData).map((item) => (
                  <div
                    key={item}
                    className={`ai-ml-usecases-menu-item ${
                      activeTab === item ? "ai-ml-usecases-active" : ""
                    }`}
                    onClick={() => setActiveTab(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>

              <div className="col-md-8 ai-ml-usecases-right">
                <ul className="ai-ml-usecases-list">
                  {useCasesData[activeTab]?.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};

export default Data_Administrator;
